import GET_WHOLESALE_GENDERS from './getWholesaleGenders.graphql'

export default GET_WHOLESALE_GENDERS
